export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">关于我们</h2>
          <p className="text-sm text-foreground-500">了解爱豆影视的故事与使命</p>
        </div>

        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-10">
          <div className="space-y-5 text-sm text-foreground-700 leading-relaxed">
            <p>
              <strong className="text-foreground-950">爱豆影视</strong>成立于2020年，是一个专注于高清流畅在线观影的免费影视平台。我们致力于为广大影迷和剧迷提供最新、最全、最高清的影视资源，涵盖电视剧、电影、综艺、动漫、纪录片等多个品类。
            </p>
            <p>
              平台采用先进的视频播放技术与智能CDN调度系统，确保用户在观看热门内容时也能享受<strong className="text-foreground-950">不缓冲、不卡顿</strong>的流畅体验。从1080P到4K超清，多种画质自由切换，满足不同网络环境下的观影需求。
            </p>
            <p>
              爱豆影视坚持<strong className="text-foreground-950">永久免费、无需注册</strong>的运营理念，所有内容面向全网用户开放。播放页面无弹窗广告干扰，让观众回归最纯粹的观影享受。每日同步更新热播剧集和最新电影，好内容不等待。
            </p>
            <p>
              截至目前，爱豆影视已收录超过<strong className="text-primary-600">20000部</strong>影视资源，日均服务数百万观影用户。未来我们将继续扩充内容库，优化播放体验，成为您身边最值得信赖的免费观影伙伴。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
            {[
              { num: '2020', label: '创立年份' },
              { num: '20000+', label: '影视资源' },
              { num: '每日更新', label: '内容同步' },
              { num: '永久免费', label: '运营理念' },
            ].map((stat) => (
              <div key={stat.label} className="p-3 rounded-xl bg-background-50">
                <div className="text-xl font-heading text-primary-500">{stat.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}